// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"NeedDesignList_contentComponent__3K2b8","tableContainer":"NeedDesignList_tableContainer__1FM-O"};